export var sanitize = function sanitize(string) {
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var regex = /<([^>]+)>/gi;
  return string.replace(regex, replacement);
};

// Позволяет писать буквы и цифры, очищает от HTML тегов.
export var sanitizeSearch = function sanitizeSearch(string) {
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var regex = /<([^>]+)>|[/<>|?!]/gi;
  return string.replace(regex, replacement);
};